import { useCallback, useEffect, useMemo, useState } from 'react';
import { useQuoteReleatedQuote } from '@/website/hooks/useQuoteReleatedQuote';
import { QuoteFromPageSourceEnum } from '@jove-frontend/enums';
import { useLocalTranslation } from '@jove-frontend/uikit';
import { debounce } from 'lodash';

interface GetQuoteSuspendedButtonProps {
  quoteSourceChannel?: QuoteFromPageSourceEnum;
}
const GetQuoteSuspendedButton = (props: GetQuoteSuspendedButtonProps) => {
  const { quoteSourceChannel } = props;
  const { $t } = useLocalTranslation();
  const { jumpToQuotePageAction } = useQuoteReleatedQuote();
  const [isVisible, setIsVisible] = useState(false);

  const windowScrollAction = () => {
    if (window.scrollY >= 500) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  /**
   * effects
   */
  const debouncedHandleScroll = useMemo(() => debounce(windowScrollAction, 50), [windowScrollAction]);

  useEffect(() => {
    window.addEventListener('scroll', debouncedHandleScroll);

    return () => {
      window.removeEventListener('scroll', debouncedHandleScroll);
      debouncedHandleScroll.cancel();
    };
  }, [debouncedHandleScroll]);

  /**
   * methods
   */
  const getQuoteAction = () => {
    jumpToQuotePageAction({
      quoteSourceChannel,
    });
  };

  return isVisible ? (
    <button
      id="get-quote-suspended-button"
      className="promotion-floating-button text-md fixed bottom-5 right-5 z-50 rounded-full px-5 py-3 font-black text-white shadow-md transition-all duration-300 hover:shadow-lg md:bottom-10 md:right-10 md:px-8 md:py-4 md:text-lg"
      onClick={getQuoteAction}
    >
      {$t('page:GetQuoteButton.get_a_quote')}
    </button>
  ) : null;
};

export default GetQuoteSuspendedButton;
